import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CONFIRM_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { getConfirmationModal } from '@commons/Modals/ConfirmationModal';

export const getResetWarningModalParams = ({ handleReset, formattedDate }) =>
  getConfirmationModal({
    type: 'warning',
    title: i18next.t('FORECAST.POS_PRODUCTION_PLANNING.RESET_WARNING_MODAL_TITLE'),
    icon: '/images/inpulse/refresh-white-small.svg',
    content: i18next.t('PRODUCTION.PLANNING.RESET_WARNING_MODAL_CONTENT', {
      date: formattedDate,
    }),
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_CONFIRM_BUTTON(),
        handleClick: handleReset,
      },
    ],
  });
